import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AnimatedCol from "../../../../../../components/AnimatedCol";
import AlertBox from "../../../../../../components/Messages.jsx";
import { berechneVerformungsbegrenzung } from "../../../../../../services/knickenBerechnungen.service";
import { selectBemessungslast } from "../../../../../../store/slices/bemessungslastSlice";
import {
  selectDickeWeicheBodenschicht,
  selectQuerschnittsnachweis,
  selectUndraenierteScherfestigkeit,
  selectVerpresskoerperdurchmesser,
  setCarryingElementErrorInNachweis,
} from "../../../../../../store/slices/innereSlice";
import AnzahlHalbwellen from "./AnzahlHalbwellen";
import Bettungsziffer from "./Bettungsziffer";
import BiegemomentDesPfahls from "./BiegemomentDesPfahls";
import ElastischerBereichDerSeitlichenBettung from "./ElastischerBereichDerSeitlichenBettung";
import Ersatzimperfektionsamplitude from "./Ersatzimperfektionsamplitude";
import Fliessdruck from "./Fliessdruck";
import Halbwellenlaenge from "./Halbwellenlaenge";
import KnicklastDesErsatzstabes from "./KnicklastDesErsatzstabes";
import KnicklastDesGebettetenPfahls from "./KnicklastDesGebettetenPfahls";
import Querschnittsnachweis from "./Querschnittsnachweis";
import SchlankheitDesErsatzstabes from "./SchlankheitDesErsatzstabes";
import Verformungsamplitude from "./Verformungsamplitude";
import Verformungsbegrenzung from "./Verformungsbegrenzung";

function Nachweis({
  expand,
  qy,
  elastischerBereichDerSeitlichenBettung,
  c,
  m,
  Lhw,
  lambda1,
  eo,
  Nki1,
  knicklastDesGebettetenPfahls,
  verformungsamplitude,
  normalkrafttragfaehigkeit,
  biegemomentdesPfahls,
  elastischeMomententragfaehigkeit,
}) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const bemessungslast = Number(useSelector(selectBemessungslast));
  const querschnittsnachweis = useSelector(selectQuerschnittsnachweis);
  const bemessungswertDruckkraft = Number(useSelector(selectBemessungslast));
  const dickeWeicheBodenschicht = useSelector(selectDickeWeicheBodenschicht);
  const undraenierteScherfestigkeit = useSelector(selectUndraenierteScherfestigkeit);
  const verpresskoerperdurchmesser = useSelector(selectVerpresskoerperdurchmesser);

  const [showAlerting, setShowAlerting] = useState(false);
  const [verformungsbegrenzung, setVerformungsbegrenzung] = useState();

  useEffect(() => {
    setVerformungsbegrenzung(
      berechneVerformungsbegrenzung(verformungsamplitude, elastischerBereichDerSeitlichenBettung)
    );
  }, [verformungsamplitude, elastischerBereichDerSeitlichenBettung]);

  useEffect(() => {
    let error;

    if (
      // undefined, null or Nan
      dickeWeicheBodenschicht == undefined ||
      isNaN(dickeWeicheBodenschicht) ||
      undraenierteScherfestigkeit == undefined ||
      isNaN(undraenierteScherfestigkeit) ||
      verpresskoerperdurchmesser == undefined ||
      isNaN(verpresskoerperdurchmesser)
    ) {
      // => kein Error, eingabe muss erst erfolgen
      error = false;
    } else {
      error = !(
        verformungsbegrenzung <= 1 &&
        bemessungslast <= knicklastDesGebettetenPfahls &&
        querschnittsnachweis <= 1 &&
        bemessungswertDruckkraft <= knicklastDesGebettetenPfahls
      );
    }
    setShowAlerting(error);
    dispatch(setCarryingElementErrorInNachweis(error));
  }, [
    verformungsbegrenzung,
    bemessungslast,
    querschnittsnachweis,
    bemessungswertDruckkraft,
    knicklastDesGebettetenPfahls,
  ]);

  return (
    <div>
      <div className="row">
        <div className={`col-md-12`}>
          <h1>{t("inner.buckling.ofner.Verification.headline")}</h1>
        </div>
      </div>
      <div className="row">
        <AnimatedCol expand={expand}>
          <Fliessdruck fliessdruck={qy} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <ElastischerBereichDerSeitlichenBettung
            elastischerBereichDerSeitlichenBettung={elastischerBereichDerSeitlichenBettung}
          />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Bettungsziffer bettungsziffer={c} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <AnzahlHalbwellen anzahlHalbwellen={m} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Halbwellenlaenge halbwellenlaenge={Lhw} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <SchlankheitDesErsatzstabes lambda={lambda1} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <KnicklastDesErsatzstabes knicklastDesErsatzstabes={Nki1} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <KnicklastDesGebettetenPfahls
            knicklastDesGebettetenPfahls={knicklastDesGebettetenPfahls}
          />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Ersatzimperfektionsamplitude ersatzimperfektionsamplitude={eo} />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <BiegemomentDesPfahls
            bemessungslast={bemessungslast}
            knicklastDesGebettetenPfahls={knicklastDesGebettetenPfahls}
            biegemomentdesPfahls={biegemomentdesPfahls}
          />
        </AnimatedCol>
        <AnimatedCol expand={expand}>
          <Verformungsamplitude
            bemessungslast={bemessungslast}
            knicklastDesGebettetenPfahls={knicklastDesGebettetenPfahls}
            verformungsamplitude={verformungsamplitude}
          />
        </AnimatedCol>

        <AnimatedCol>
          <Querschnittsnachweis
            knicklastDesGebettetenPfahls={knicklastDesGebettetenPfahls}
            normalkrafttragfaehigkeit={normalkrafttragfaehigkeit}
            biegemomentdesPfahls={biegemomentdesPfahls}
            elastischeMomententragfaehigkeit={elastischeMomententragfaehigkeit}
          />
        </AnimatedCol>
        <AnimatedCol>
          <Verformungsbegrenzung
            verformungsamplitude={verformungsamplitude}
            elastischerBereichDerSeitlichenBettung={elastischerBereichDerSeitlichenBettung}
            verformungsbegrenzung={verformungsbegrenzung}
            knicklastDesGebettetenPfahls={knicklastDesGebettetenPfahls}
            greenOn={verformungsbegrenzung <= 1 && bemessungslast <= knicklastDesGebettetenPfahls}
          />
        </AnimatedCol>
        <AnimatedCol>
          <Col md={8}>
            <AlertBox
              show={showAlerting}
              message={t("inner.buckling.ofner.Verification.errorText.needBiggerElement")}
            />
          </Col>
        </AnimatedCol>
      </div>
    </div>
  );
}

export default Nachweis;
